import {RegexHelper} from '~/helpers/regexHelper'
import RegexValidator from './regexValidator'

export default class EmailValidator<R> extends RegexValidator<R> {
  matcher: RegExp = RegexHelper.emailOrBlank

  protected _validate(value: string): void {
    this.isValid = this.test(value)
    if (this.isValid) {
      this.errorMessage = ''
    } else {
      this.errorMessage = this.validationMessage || this.buildMessage({ suffix: 'a valid email address' })
    }
  }
}